import { TemplateRef, Directive } from '@angular/core';

@Directive({
    selector: '[aaStepContent]',
    standalone: false
})
export class StepContentDirective
{
    constructor(public templateRef: TemplateRef<any>) { }
}
